import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MenuItem } from "@/types/menu.type";
import SidebarComponent from "./SidebarComponent.vue";
import { onMounted, reactive } from "vue";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items = reactive<MenuItem[]>([
  {
    icon: "el-icon el-icon-home fas",
    index: "/admin",
    title: "menu.home",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-map-marker fas",
    index: "/admin/stations",
    title: "menu.stations",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-box fas",
    index: "/admin/containers",
    title: "menu.containers",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye fas",
    index: "/admin/samplingPoints",
    title: "menu.samplingPoints",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-user fas",
    index: "/admin/users",
    title: "menu.users",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye-dropper fas",
    index: "/admin/parameters",
    title: "menu.parameters",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-database fas",
    index: "/admin/opendata",
    title: "menu.opendata",
    subs: [
      {
        icon: "",
        index: "/admin/saica",
        title: "menu.saica",
        disabled: false,
      },
      {
        icon: "",
        index: "/admin/saih",
        title: "menu.saih",
        disabled: false,
      },
      {
        icon: "",
        index: "/admin/aemet",
        title: "menu.aemet",
        disabled: false,
      },
    ],
    disabled: false,
  },
]);

const store = useStore<RootState>();

onMounted(async () => {
  if (store.state.auth.user?.id) {
    let userRoutes = await getAvailableRoutes(store.state.auth.user.id);

    if (userRoutes && Array.isArray(userRoutes) && userRoutes.length > 0) {
      items.forEach((item) => {
        item.disabled = !userRoutes.includes(item.index);
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidebarComponent, { items: _unref(items) }, null, 8, ["items"]))
}
}

})